// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.projects-container {
  text-align: center;
  padding: 20px;
  background-color: #f9f9f9;
}

.projects-container h2 {
  font-size: 24px;
  margin-bottom: 20px;
}

.projects-grid {
  display: flex;
  gap: 20px;
  overflow-x: auto; /* Enable horizontal scrolling */
  scroll-behavior: smooth; /* Smooth scrolling */
  padding-right: 12.5%; /* Reserve space for partial visibility of the last card */
  scrollbar-width: none; /* Hide scrollbar for Firefox */
  -ms-overflow-style: none; /* Hide scrollbar for IE and Edge */
  position: relative;
}

.projects-grid::-webkit-scrollbar {
  display: none; /* Hide scrollbar for Chrome, Safari, and Opera */
}

.project-card {
  flex: 0 0 25%; /* Each card takes up 25% of the container width */
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  text-align: left;
  
}

.project-image {
  width: 100%;
  height: 170px;
  object-fit: cover;
  margin-bottom: 20px;
}

.project-info {
  padding: 10px;
}

.project-info h3 {
  font-size: 18px;
  margin-bottom: 10px;
}

.project-info p {
  font-size: 12px;
  color: #666666;
  line-height: 1.6;
}

/* Assign colors to each card and repeat for the last card */
.project-card:nth-child(1) {
  background-color: #DADADA; /* Light gray */
}

.project-card:nth-child(2) {
  background-color: #DFD3CB; /* Light beige */
}

.project-card:nth-child(3) {
  background-color: #FFF8EE; /* Light cream */
}

.project-card:nth-child(4){
  background-color: #FFEEE1; /* Light peach (repeat color for extra cards) */

}
.project-card:nth-child(5) {
  background-color: #FFEEE1; /* Light peach (repeat color for extra cards) */
}

/* Display the last card partially */
.projects-grid .project-card:last-child {
  margin-right: -12.5%; /* Ensure last card is partially visible */
}

/* Hover behavior for the last card */
.projects-grid:hover {
  overflow-x: auto; /* Enable scroll only on hover */
}



/* Mobile view adjustments for screens <= 768px */
@media (max-width: 768px) {
  .projects-grid {
    flex-direction: column; /* Stack the cards vertically */
    overflow-x: hidden; /* Remove horizontal scrolling */
    padding: 10%; /* Remove extra padding */
  }

  .project-card {
    flex: 0 0 auto; /* Reset flex property */
    width: 100%; /* Full width for mobile view */
   
    margin-bottom: 20px; /* Add space between stacked cards */
  }

  .project-image {
    height: 200px; /* Increase image height for better visibility */
  }

  .projects-grid .project-card:last-child {
    margin-right: 0; /* Remove margin for the last card in mobile view */
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MajorProjects/MajorProjects.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB,EAAE,gCAAgC;EAClD,uBAAuB,EAAE,qBAAqB;EAC9C,oBAAoB,EAAE,0DAA0D;EAChF,qBAAqB,EAAE,+BAA+B;EACtD,wBAAwB,EAAE,mCAAmC;EAC7D,kBAAkB;AACpB;;AAEA;EACE,aAAa,EAAE,iDAAiD;AAClE;;AAEA;EACE,aAAa,EAAE,kDAAkD;EACjE,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;;AAElB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,yBAAyB,EAAE,eAAe;AAC5C;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;AAC7C;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;AAC7C;;AAEA;EACE,yBAAyB,EAAE,+CAA+C;;AAE5E;AACA;EACE,yBAAyB,EAAE,+CAA+C;AAC5E;;AAEA,oCAAoC;AACpC;EACE,oBAAoB,EAAE,0CAA0C;AAClE;;AAEA,qCAAqC;AACrC;EACE,gBAAgB,EAAE,gCAAgC;AACpD;;;;AAIA,iDAAiD;AACjD;EACE;IACE,sBAAsB,EAAE,+BAA+B;IACvD,kBAAkB,EAAE,gCAAgC;IACpD,YAAY,EAAE,yBAAyB;EACzC;;EAEA;IACE,cAAc,EAAE,wBAAwB;IACxC,WAAW,EAAE,+BAA+B;;IAE5C,mBAAmB,EAAE,oCAAoC;EAC3D;;EAEA;IACE,aAAa,EAAE,gDAAgD;EACjE;;EAEA;IACE,eAAe,EAAE,mDAAmD;EACtE;AACF","sourcesContent":[".projects-container {\n  text-align: center;\n  padding: 20px;\n  background-color: #f9f9f9;\n}\n\n.projects-container h2 {\n  font-size: 24px;\n  margin-bottom: 20px;\n}\n\n.projects-grid {\n  display: flex;\n  gap: 20px;\n  overflow-x: auto; /* Enable horizontal scrolling */\n  scroll-behavior: smooth; /* Smooth scrolling */\n  padding-right: 12.5%; /* Reserve space for partial visibility of the last card */\n  scrollbar-width: none; /* Hide scrollbar for Firefox */\n  -ms-overflow-style: none; /* Hide scrollbar for IE and Edge */\n  position: relative;\n}\n\n.projects-grid::-webkit-scrollbar {\n  display: none; /* Hide scrollbar for Chrome, Safari, and Opera */\n}\n\n.project-card {\n  flex: 0 0 25%; /* Each card takes up 25% of the container width */\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  text-align: left;\n  \n}\n\n.project-image {\n  width: 100%;\n  height: 170px;\n  object-fit: cover;\n  margin-bottom: 20px;\n}\n\n.project-info {\n  padding: 10px;\n}\n\n.project-info h3 {\n  font-size: 18px;\n  margin-bottom: 10px;\n}\n\n.project-info p {\n  font-size: 12px;\n  color: #666666;\n  line-height: 1.6;\n}\n\n/* Assign colors to each card and repeat for the last card */\n.project-card:nth-child(1) {\n  background-color: #DADADA; /* Light gray */\n}\n\n.project-card:nth-child(2) {\n  background-color: #DFD3CB; /* Light beige */\n}\n\n.project-card:nth-child(3) {\n  background-color: #FFF8EE; /* Light cream */\n}\n\n.project-card:nth-child(4){\n  background-color: #FFEEE1; /* Light peach (repeat color for extra cards) */\n\n}\n.project-card:nth-child(5) {\n  background-color: #FFEEE1; /* Light peach (repeat color for extra cards) */\n}\n\n/* Display the last card partially */\n.projects-grid .project-card:last-child {\n  margin-right: -12.5%; /* Ensure last card is partially visible */\n}\n\n/* Hover behavior for the last card */\n.projects-grid:hover {\n  overflow-x: auto; /* Enable scroll only on hover */\n}\n\n\n\n/* Mobile view adjustments for screens <= 768px */\n@media (max-width: 768px) {\n  .projects-grid {\n    flex-direction: column; /* Stack the cards vertically */\n    overflow-x: hidden; /* Remove horizontal scrolling */\n    padding: 10%; /* Remove extra padding */\n  }\n\n  .project-card {\n    flex: 0 0 auto; /* Reset flex property */\n    width: 100%; /* Full width for mobile view */\n   \n    margin-bottom: 20px; /* Add space between stacked cards */\n  }\n\n  .project-image {\n    height: 200px; /* Increase image height for better visibility */\n  }\n\n  .projects-grid .project-card:last-child {\n    margin-right: 0; /* Remove margin for the last card in mobile view */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
